import React from "react";

const Hero = () => {
  return (
    <section className="bg-[#F9FAFB] pt-24 pb-32 px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute top-[-10%] right-[-10%] w-[40%] h-[40%] bg-[#0077C8]/10 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[30%] h-[30%] bg-[#22C55E]/5 rounded-full blur-[100px]"></div>
      </div>
      <div className="max-w-[960px] mx-auto text-center relative z-10">
        <h1 className="text-4xl md:text-6xl font-extrabold leading-[1.1] tracking-tight mb-8 text-[#050B15]">
          Can your Board prove your internal controls actually work?
        </h1>
        <h2 className="text-xl md:text-2xl text-gray-700 font-medium leading-relaxed max-w-[800px] mx-auto mb-12">
          Miporis gives CFOs and Boards defensible, audit-ready assurance — without adding headcount.
        </h2>
        <div className="flex flex-col items-center gap-6">
          <button 
            className="bg-[#0077C8] text-white px-10 py-5 rounded-lg text-lg font-bold hover:scale-[1.02] transition-transform shadow-xl shadow-[#0077C8]/20 flex items-center gap-3"
            onClick={() => {
              window.location.href = "mailto:john@dagalagroup.com?subject=Provision 29 Readiness Call";
            }}
          >
            <span className="material-symbols-outlined text-2xl">calendar_today</span>
            <span>Book a Provision 29 Readiness Call</span>
          </button>
          <p className="text-sm text-gray-600 font-medium">
            Used by CFOs preparing for audits, boards, and Provision 29 scrutiny.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
